// import React from "react";
import React, { useEffect, useState } from "react";
import WlcomeImage from "../PicsForPages/WelcomePageImageToVedio.png";
// import Floor_Plans_Image01 from "../PicsForPages/FloorPlaneImage01.webp";
// import Floor_Plans_Image02 from "../PicsForPages/FloorPlaneImage02.webp";
import Floor_Plans_Image03 from "../PicsForPages/FloorPlaneImage03.webp";
import Floor_Plans_Image04 from "../PicsForPages/FloorPlaneImage04.webp";
import Floor_Plans_Image05 from "../PicsForPages/FloorPlaneImage05.webp";
import coverImage1 from "../PicsForPages/55CoverPageImage00.webp";
import coverImage2 from "../PicsForPages/55CoverPageImage01.png";
import UseScrollAnimation from "../Elements/ScrollAnimation";

function HomePage() {
  UseScrollAnimation(); // ✅ just call it

  const [startAnimation, setStartAnimation] = useState(false);
  const images = [coverImage1, coverImage2];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);

  useEffect(() => {
    // Step 1: after 3s → show 2nd image
    const timer = setTimeout(() => {
      setCurrentIndex(1);
      setPrevIndex(0);

      // Step 2: start animation AFTER showing 2nd image
      setTimeout(() => {
        setStartAnimation(true);
      }, 0); // small delay
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  // ✅ Animation slider (runs only AFTER startAnimation = true)
  useEffect(() => {
    if (!startAnimation) return;

    const interval = setInterval(() => {
      setPrevIndex(currentIndex);
      setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }, 4000);

    return () => clearInterval(interval);
  }, [startAnimation, currentIndex, images.length]);

  return (
    <div className="homepageParent">
      <div className="homepaageBox">
        <div className="homepage55Parent">
          {images.map((img, index) => {
            let className = "slide";

            if (!startAnimation) {
              // BEFORE animation → just show current image
              if (index === currentIndex) {
                className += " showStatic";
              }
            } else {
              // AFTER animation → sliding effect
              if (index === currentIndex) {
                className += " active";
              } else if (index === prevIndex) {
                className += " exit";
              }
            }

            return (
              <div
                key={index}
                className={className}
                style={{ backgroundImage: `url(${img})` }}
              />
            );
          })}

          <div className="homepage55Box">
            <div className="homepage55BoxPara animate-top">
              Cornelius Woods is a 55+ active adult retirement community that
              offers upscale condos from one to three bedrooms located in
              Cornelius, NC.
            </div>
          </div>
        </div>

        <div className="homepageWelcomeParent">
          <div className="homepageWelcomeBox">
            <div className="homepageWelcomeBoxLeft">
              <img
                fetchPriority="high"
                loading="eager"
                src={WlcomeImage}
                alt="homepageWelcomeBoxLeftImage"
                className="homepageWelcomeBoxLeftImage animate-top"
              />
            </div>
            <div className="homepageWelcomeBoxRight">
              <div className="homepageWelcomeBoxRightBox">
                <div className="homepageWelcomeBoxRightBoxHeading animate-top">
                  Welcome to Cornelius Woods
                </div>
                <div className="homwpageWelcomeBoxRightBoxPara animate-top">
                  Welcome to Cornelius Woods, the premier 55+ active adult
                  retirement community nestled in the heart of Cornelius, North
                  Carolina. Discover a life of luxury, comfort, and convenience
                  as you explore our upscale condos boasting one to three
                  bedrooms. At Cornelius Woods, we understand that retirement is
                  a time for new beginnings and enriching experiences. That's
                  why we've created a vibrant community that caters to your
                  active lifestyle while providing a serene and picturesque
                  setting.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="homepageThankfulParent">
          <div className="homepageThankfulBox animate-top">
            <span>" Cornelius Woods is the perfect place for us.</span>
            <span>I'm thankful we found it "</span>
          </div>
        </div>
        <div className="homepageFloor_PlansParent">
          <div className="homepageFloor_PlansBox">
            <div className="homepageFloor_PlansBoxHeading">
              <span className="homepageFloor_PlansBoxHeadingWord animate-top">
                Floor Plans
              </span>
              <span className="homepageFloor_PlansBoxHeadingLine animate-top"></span>
            </div>
            {/* <div className="homepageFloor_PlansBoxSectionBox">
              <div className="homepageFloor_PlansBoxSectionBoxTitle">
                Sweetbay
              </div>
              <div className="homepageFloor_PlansBoxSectionBoxPara">
                2 Bedrooms / 2 Bathrooms / 1,255 SQ.FT
              </div>
              <div className="homepageFloor_PlansBoxSectionBoxImageDiv">
                <img fetchPriority="high"
                  loading="eager"
                  src={Floor_Plans_Image01}
                  alt="homepageFloor_PlansBoxSectionBoxImage"
                  className="homepageFloor_PlansBoxSectionBoxImage"
                />
              </div>
            </div>
            <div className="homepageFloor_PlansBoxSectionBox">
              <div className="homepageFloor_PlansBoxSectionBoxTitle">
                Redbud
              </div>
              <div className="homepageFloor_PlansBoxSectionBoxPara">
                1 Bedroom / 1 Bathroom / 1,055 SQ.FT
              </div>
              <div className="homepageFloor_PlansBoxSectionBoxImageDiv">
                <img fetchPriority="high"
                  loading="eager"
                  src={Floor_Plans_Image02}
                  alt="homepageFloor_PlansBoxSectionBoxImage"
                  className="homepageFloor_PlansBoxSectionBoxImage"
                />
              </div>
            </div> */}

            <div className="homepageFloor_PlansBoxSectionParent">
              <div className="homepageFloor_PlansBoxSectionBox animate-top">
                <div className="homepageFloor_PlansBoxSectionBoxTitle">
                  Camilia
                </div>
                <div className="homepageFloor_PlansBoxSectionBoxPara">
                  1 Bedroom / 1.5 Bathroom / 1,475 SQ.FT
                </div>
                <div className="homepageFloor_PlansBoxSectionBoxImageDiv">
                  <img
                    fetchPriority="high"
                    loading="eager"
                    src={Floor_Plans_Image03}
                    alt="homepageFloor_PlansBoxSectionBoxImage"
                    className="homepageFloor_PlansBoxSectionBoxImage"
                  />
                </div>
              </div>
              <div className="homepageFloor_PlansBoxSectionBox animate-top">
                <div className="homepageFloor_PlansBoxSectionBoxTitle">
                  Tupelo
                </div>
                <div className="homepageFloor_PlansBoxSectionBoxPara">
                  2 Bedrooms / 2 Bathrooms / 1,675 SQ.FT
                </div>
                <div className="homepageFloor_PlansBoxSectionBoxImageDiv">
                  <img
                    fetchPriority="high"
                    loading="eager"
                    src={Floor_Plans_Image05}
                    alt="homepageFloor_PlansBoxSectionBoxImage"
                    className="homepageFloor_PlansBoxSectionBoxImage"
                  />
                </div>
              </div>
              <div className="homepageFloor_PlansBoxSectionBox animate-top">
                <div className="homepageFloor_PlansBoxSectionBoxTitle">
                  Holly
                </div>
                <div className="homepageFloor_PlansBoxSectionBoxPara">
                  2 Bedrooms / 2 Bathrooms / 1,750 SQ.FT
                </div>
                <div className="homepageFloor_PlansBoxSectionBoxImageDiv">
                  <img
                    fetchPriority="high"
                    loading="eager"
                    src={Floor_Plans_Image04}
                    alt="homepageFloor_PlansBoxSectionBoxImage"
                    className="homepageFloor_PlansBoxSectionBoxImage"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="homepageExterior_AmenitiesParent">
          <div className="homepageExterior_AmenitiesBox">
            <div className="homepageExterior_AmenitiesBoxHeading">
              <span className="homepageExterior_AmenitiesBoxHeadingWord animate-top">
                Exterior Amenities
              </span>
              <span className="homepageExterior_AmenitiesBoxHeadingLine animate-top"></span>
            </div>
            <div className="homepageExterior_AmenitiesBoxSectionParent">
              <div className="homepageExterior_AmenitiesBoxSectionParent00">
                <div className="homepageExterior_AmenitiesBoxSectionBox animate-top">
                  <div className="homepageExterior_AmenitiesBoxSectionBoxHeading animate-top">
                    Fenced Dog Park
                  </div>
                  <div className="homepageExterior_AmenitiesBoxSectionBoxPara animate-top">
                    Embrace a unique community that understands and values your
                    beloved pets as much as you do. At Cornelius Woods, we offer
                    a secure, fenced Dog Park – a haven where your furry friends
                    can roam free and socialize with other pets. Tail-wagging
                    adventures await in this beautifully maintained, expansive
                    green space.
                  </div>
                </div>

                <div className="homepageExterior_AmenitiesBoxSectionBox animate-top">
                  <div className="homepageExterior_AmenitiesBoxSectionBoxHeading animate-top">
                    Walking Trial
                  </div>
                  <div className="homepageExterior_AmenitiesBoxSectionBoxPara animate-top">
                    Recharge, rejuvenate, and reconnect with nature on our
                    enchanting Walking Trail. Nestled amidst lush, green
                    surroundings, the trail offers you the perfect setting for
                    tranquil morning strolls or invigorating evening walks.
                    Witness the blend of wellness and scenic beauty, right at
                    your doorstep.
                  </div>
                </div>

                <div className="homepageExterior_AmenitiesBoxSectionBox animate-top">
                  <div className="homepageExterior_AmenitiesBoxSectionBoxHeading animate-top">
                    Pickleball Courts
                  </div>
                  <div className="homepageExterior_AmenitiesBoxSectionBoxPara animate-top">
                    Stay active and enjoy friendly competition on our
                    state-of-the-art Pickleball Courts. Whether you're a
                    seasoned player or a curious newbie, these courts promise
                    exhilarating games, a lively community spirit, and a
                    fantastic way to maintain your fitness goals.
                  </div>
                </div>
              </div>
              <div className="homepageExterior_AmenitiesBoxSectionParent00">
                <div className="homepageExterior_AmenitiesBoxSectionBox">
                  <div className="homepageExterior_AmenitiesBoxSectionBoxHeading animate-top">
                    {/* Garden Space and Fire Pit */}
                    Pocket Park
                  </div>
                  <div className="homepageExterior_AmenitiesBoxSectionBoxPara animate-top">
                    Enjoy the tranquility of our shared Garden Space, a serene
                    escape where you can cultivate your green thumb or simply
                    relish the serenity. As the day ends, gather around the cozy
                    Fire Pit. Share stories, make memories, and experience the
                    warmth of the community under the starlit sky.
                  </div>
                </div>

                <div className="homepageExterior_AmenitiesBoxSectionBox">
                  <div className="homepageExterior_AmenitiesBoxSectionBoxHeading animate-top">
                    Exterior Electric Vehicle Charging
                  </div>
                  <div className="homepageExterior_AmenitiesBoxSectionBoxPara animate-top">
                    Take advantage of our exterior electric vehicle charging
                    stations, designed to support your sustainable lifestyle.
                    Power up your vehicle with ease while you relax at home,
                    knowing modern comfort and eco-conscious living come
                    together seamlessly in our community.
                  </div>
                </div>

                <div className="homepageExterior_AmenitiesBoxSectionBox">
                  <div className="homepageExterior_AmenitiesBoxSectionBoxHeading animate-top">
                    Covered Parking
                  </div>
                  <div className="homepageExterior_AmenitiesBoxSectionBoxPara animate-top">
                    Every detail at Cornelius Woods is designed with your
                    convenience in mind. Our Covered Parking facility ensures
                    your vehicles are protected from the elements at all times.
                    Easy to access and secure, we've taken care of the smallest
                    details to offer you peace of mind and an unrivaled living
                    experience.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="homepageLongVideoParent "></div>
      </div>
    </div>
  );
}

export default HomePage;
